<template>
  <div v-if="$store.state.responsive.viewDesktopFilters">
    <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
      <div class="row">
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="vendor">Nombre de usuario</label>
            <input type="text" class="form-control generalInput" id="vendor" v-model.trim="username">
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="vendor">Vendor</label>
            <input type="text" class="form-control generalInput" id="vendor" v-model.trim="vendor">
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="email">Correo electrónico</label>
            <input type="text" class="form-control generalInput" id="email" v-model.trim.lazy="v$.email.$model">
            <div v-if="v$.email.$dirty">
              <small class="form-text text-danger" v-if="v$.email.email.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="tenant">Tenant</label>
            <VueNextSelect class="form-control generalInput" id="tenant" :options="tenantsData" v-model.trim="tenant"
              close-on-select placeholder="" searchable="true" clear-on-close="true" aria-labelledby="Tenant"></VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="store">Store</label>
            <VueNextSelect class="form-control generalInput" id="store" :options="storesData" v-model.trim="store"
              close-on-select placeholder="" searchable="true" clear-on-close="true" aria-labelledby="Store"></VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="role">Rol</label>
            <VueNextSelect class="form-control generalInput" id="role" :options="rolesData" v-model.trim="rol"
              close-on-select placeholder="" aria-labelledby="Rol"></VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-12">
          <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
            <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
            <button class="btn btn-primary generalPrimaryButton">Buscar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div v-else>
    <div class="filterHeader link-primary d-flex align-items-center justify-content-between" data-toggle="collapse" href="#filterCollapse" role="button" aria-expanded="false" aria-controls="filterCollapse">
      <p class="m-0">
        FILTROS
      </p>
      <v-icon name="bi-filter" scale="1.5" />
    </div>
    <hr/>
    <div class="collapse" id="filterCollapse">
      <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
        <div class="row">
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="vendor">Nombre de usuario</label>
              <input type="text" class="form-control generalInput" id="vendor" v-model.trim="username">
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="vendor">Vendor</label>
              <input type="text" class="form-control generalInput" id="vendor" v-model.trim="vendor">
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="email">Correo electrónico</label>
              <input type="text" class="form-control generalInput" id="email" v-model.trim.lazy="v$.email.$model">
              <div v-if="v$.email.$dirty">
                <small class="form-text text-danger" v-if="v$.email.email.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="tenant">Tenant</label>
              <VueNextSelect class="form-control generalInput" id="tenant" :options="tenantsData" v-model.trim="tenant"
                close-on-select placeholder="" searchable="true" clear-on-close="true" aria-labelledby="Tenant"></VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="store">Store</label>
              <VueNextSelect class="form-control generalInput" id="store" :options="storesData" v-model.trim="store"
                close-on-select placeholder="" searchable="true" clear-on-close="true" aria-labelledby="Store"></VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="role">Rol</label>
              <VueNextSelect class="form-control generalInput" id="role" :options="rolesData" v-model.trim="rol"
                close-on-select placeholder="" aria-labelledby="Rol"></VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-12">
            <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
              <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
              <button class="btn btn-primary generalPrimaryButton">Buscar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import VueNextSelect from 'vue-next-select'
import useVuelidate from '@vuelidate/core';
import axios from 'axios';
import {
  email,
} from '@vuelidate/validators'
export default {
  name: 'UserFilters',
  setup() {
    return { v$: useVuelidate() }
  },
  created() {
    this.loadTenantData();
    this.loadStoresData();
  },
  components: {
    VueNextSelect
  },
  data() {
    return {
      username: '',
      vendor: '',
      tenant: '',
      email: '',
      store: '',
      rol: '',
      tenantsData: [],
      storesData: [],
      rolesData: ['super_admin', 'admin', 'Backoffice_member', 'Backoffice_supervisor', 'Backoffice_Superadmin'],
    };
  },
  validations() {
    return {
      email: {
        email,
      },
    }
  },
  computed: {
    filtersApplied() {
      return {
        username: this.username,
        vendor: this.vendor,
        tenant: this.tenant,
        email: this.email,
        store: this.store,
        rol: this.rol,
      };
    },
  },
  methods: {
    filter() {
      this.$emit('filter', this.filtersApplied);
    },
    cleanSearch() {
      this.username = '';
      this.vendor = '';
      this.tenant = '';
      this.email = '';
      this.store = '';
      this.rol = '';
    },
    loadTenantData() {
      axios.get(`/tenants`)
        .then((response) => {
          let arrayTenant = [];
          response.data.forEach(element => {
            arrayTenant.push(element.nameNormalized)
          });
          this.tenantsData = arrayTenant;
        });
    },
    loadStoresData() {
      axios.get(`/stores/codes`)
        .then((response) => {
          let arrayStores = [];
          response.data.forEach(element => {
            arrayStores.push(element)
          });
          this.storesData = arrayStores;
        });
    },
    enterKey: function (e) {
      if (e.keyCode === 13) {
        this.filter();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
